import React from 'react';

import {
    Button, Group, Loader, Stack, Text,
} from '@mantine/core';

import { unmapGame } from './api/mapGame';
import useMappedGames from './api/useMappedGames';
import { PUBLIC_DOMAIN_APP } from '../../const';
import { useQueryClient } from '../../contexts/queryClient';

const MappedGames = ({ slug, isDisabled }) => {
    const { data, isLoading } = useMappedGames({ slug, isDisabled });
    const { queryClient } = useQueryClient();

    const noSlugs = !data?.store_game_slugs?.length;

    return (
        <Stack spacing={4} m="4px 0 10px 0">
            <Text size={14} weight={500}>
                Связанные игры:
            </Text>
            {(isDisabled || noSlugs) && !isLoading && (
                <Text>—</Text>
            )}
            {isLoading && <Loader size="xs" />}
            {data?.store_game_slugs?.map((slugStore) => {
                const link = new URL(`/play/game/${slugStore}/`, PUBLIC_DOMAIN_APP).toString();

                return (
                    <Group spacing={4}>
                        <Button
                            key={slugStore}
                            variant="light"
                            size="xs"
                            compact
                            component="a"
                            href={link}
                            target="_blank"
                            rel="noreferrer"
                            display="inline-flex"
                            w="max-content"
                        >
                            {link}
                        </Button>
                        <Button
                            key={`${slugStore}-unmap`}
                            variant="light"
                            color="red"
                            size="xs"
                            compact
                            display="inline-flex"
                            w="max-content"
                            onClick={() => unmapGame({
                                slug, slugStore, queryClient,
                            })}
                        >
                            <Text size="md">
                                ×
                            </Text>
                        </Button>
                    </Group>
                );
            })}
        </Stack>
    );
};

export default MappedGames;
